// Games-page ⇄ canonical /games contract helpers (pure, framework-free).
// The backend is case-sensitive: league is UPPERCASE (NFL/NCAA), status_filter is
// lowercase (final/scheduled/in_progress). "live" is the backend's canonical
// alias that returns all live-equivalent statuses. Filtering MUST happen
// server-side — never fetch an unfiltered first page and filter it locally.

// UI status → canonical status_filter. "all" omits the param entirely.
export function statusFilterParam(uiStatus) {
  return uiStatus && uiStatus !== "all" ? uiStatus : undefined;
}

// Build the canonical query object for TurfTalk.games(). League "ALL" omits the
// league param; status "all" omits status_filter. Pagination via skip + limit.
export function gamesQueryParams({ league, status, limit = 50, skip = 0 } = {}) {
  const params = { limit, skip };
  if (league && league !== "ALL") params.league = league;
  const sf = statusFilterParam(status);
  if (sf) params.status_filter = sf;
  return params;
}

// Page merge: skip 0 replaces (resets pagination on a filter change); skip > 0
// appends the next server-side page within the active filter.
export function mergeGamesPage(prev, incoming, skip) {
  const list = Array.isArray(incoming) ? incoming : [];
  return skip === 0 ? list : [...(prev || []), ...list];
}

// Monotonic request sequencer so fast filter changes discard stale responses
// (latest request wins; out-of-order older responses are ignored).
export function makeRequestSequencer() {
  let current = 0;
  return {
    next: () => ++current,
    isCurrent: (id) => id === current,
  };
}
